'use strict';

export { createAnimatedComponent } from "./createAnimatedComponent.js";
//# sourceMappingURL=index.js.map